
<div>
  <div class="innerpage-fullwithbanner">
    <h2 class="bighead">{{pageName}}</h2>
    <ul class="bread-crumbs">
      <li *ngIf="this.Authentication.Principal() || this.Authentication.Seller() || this.Authentication.Principal1031()">
        <a (click)="onHomeBreadCrumbClick();">
          Home
          <span>|</span>
        </a>
      </li>
      <li *ngIf="!this.Authentication.Principal() && !this.Authentication.Seller() && !this.Authentication.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
      <li *ngIf="isBroker"><span>My Deals<span style="padding:8px;">|</span></span></li>
      <li>{{pageName}}</li>
    </ul>
  </div>
</div>

<div class="tabstyle2 dashboardtab " style="background:#fff;margin-top:20px;">
  <ul class="switchingproperty" *ngIf="Authentication.Broker()">
    <li [class.active]="selectedTab == 1" (click)="switchTab(1)">
      <a href="javascript:void(0);">
        Buy
      </a>
    </li>
    <li [class.active]="selectedTab == 2" (click)="switchTab(2)">
      <a href="javascript:void(0);">
        Sell
      </a>
    </li>
  </ul>
  <div class="successstep container min-heightcontainer margin-bottom-0" *ngIf="selectedTab == 1">
    <div class="featuredproperties section-margin">
      <div class="container container-lg min-heightcontainer">
        <div class="row">
          <div class="col-lg-12 ">
            <div class="border-div table-fixed margin0">
              <div class="floatinghead clearfix">
                <h2 class="mainhead "><span class="text">Offers - Buy</span></h2>
                <div class="rightside clearfix">
                  <div class="search-sec">
                    <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                    <i class="fa fa-search icon" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div class="floatinghead be-tab-02 clearfix">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a [class.active]="selectedSubTab == 1" href="javascript:void(0);" (click)="ArchiveTab(1);" class="nav-link active">
                      Active
                    </a>
                  </li>
                  <li class="nav-item">
                    <a [class.active]="selectedSubTab == 2" href="javascript:void(0);" (click)="ArchiveTab(2);" class="nav-link">
                      Inactive
                    </a>
                  </li>
                </ul>
              </div>
                <div class="table-responsive">
                  <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                    <thead>
                      <tr>
                        <th [hidden]="selectedSubTab == 2 && !this.Authentication.Admin()&&!this.Authentication.SuperAdmin()" style="width:75px" class="remove sorting_disabled" data-orderable="false">Action</th>
                        <th class="remove sorting_disabled" data-orderable="false"></th>
                        <th data-orderable="false" [hidden]="!this.Authentication.Broker()&&!this.Authentication.Principal()&&!this.Authentication.Principal1031()&&!this.Authentication.ExternalBroker() && !this.authService.Admin()&& !this.authService.SuperAdmin()">Questionnaire</th>
                        <th class="min-width-td">Tenant/Portfolio</th>
                        <th [hidden]="isBroker">Broker</th>
                        <th [hidden]="!isBroker">Principal</th>
                        <th>Asking Price</th>
                        <th>Offer Price</th>
                        <th>Earnest Money Deposit</th>
                        <th>Due Diligence Period (Days)</th>
                        <th>Closing Period (Days)</th>
                        <th>Comments</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let offer of offers ">
                        <td [hidden]="selectedSubTab == 2 && !this.Authentication.Admin()&& !this.authService.SuperAdmin()" class="whitespacenowrap">
                          <a class="bluetwo" *ngIf="!isBroker" [ngClass]="{'newnote': offer.UnReadNoteCount!=0}" tooltip="Notes" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',offer.LeadId,offer)" placement="right">
                            <i class="icon-inquiry" aria-hidden="true"></i>
                          </a>
                          <div *ngIf="offer.IsLatest && (offer.StatusId==451 || offer.StatusId==458||offer.StatusId==461) && offer.StatusId != 457" class="displayinlineblockdiv">
                            <a href="javascript:void(0);" routerLink="/place-offer/{{offer.Slug?offer.Slug:offer.PropertyGuid}}/{{offer.OfferDetailGuid}}/{{fromPage}}" class="blueone" tooltip="Modify" placement="right">
                              <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                            </a>
                          </div>
                          <div *ngIf="isBroker" class="displayinlineblockdiv">
                            <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',offer.LeadId,index)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                          </div>
                          <div class="displayinlineblockdiv">
                            <a *ngIf="this.Authentication.Broker()&&!offer.IsDraft &&(offer.QuestionareIsDraft ||(offer.NotAnsweredQustionsCount)!=34) && offer.IsHaveRemainderPermission==1" href="javascript:void(0);" tooltip="Send Reminder" placement="right" (click)="SendBuyerQuestionsRemainder(offer.LeadId)" class="remove" placement="right">
                              <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
                            </a>
                          </div>
                        </td>
                        <td>
                          <div *ngIf="offer.FilePath" class="displayinlineblockdiv">
                            <a class="border-link" href={{offer.FilePath}} download="Document.pdf" target="_blank" ng-reflect-placement="right" ng-reflect-tooltip="Download" placement="right" container="body" tooltip="Download" triggers="hover">
                              <i aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>LOI
                            </a>
                          </div>
                        </td>
                        <td class="whitespacenowrap" *ngIf="(this.Authentication.Broker()||this.Authentication.Principal()||this.Authentication.Principal1031()||this.Authentication.ExternalBroker() || this.Authentication.Admin()||this.authService.SuperAdmin())&&offer.IsHaveQuestionPermission==1">
                          <p><a href="javascript:void(0);" *ngIf="!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal  modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                          <span *ngIf="offer.QuestionareIsDraft&&!offer.IsDraft" class="red">(Draft)</span>
                          <span *ngIf="offer.IsDraft">-</span>
                        </td>
                        <td class="whitespacenowrap" *ngIf="(this.Authentication.Broker()||this.Authentication.Principal()||this.Authentication.Principal1031()||this.Authentication.ExternalBroker() || this.Authentication.Admin() || this.Authentication.SuperAdmin())&&offer.IsHaveQuestionPermission==0">
                          <p><a href="javascript:void(0);" *ngIf="!offer.QuestionareIsDraft&&offer.IsHaveRemainderPermission==1&&!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal  modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                          <span *ngIf="(offer.QuestionareIsDraft||offer.IsHaveRemainderPermission!=1||offer.IsDraft)">-</span>
                        </td>
                        <td>
                          <!--<p>{{ (offer.TenantName!=null && offer.TenantName!=" ") ? (offer.TenantName) : "-" }}</p>-->
                          <p><a href="javascript:void(0);" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute: isBroker ? 'My Deals-Buy':'My Deals-Buy',link:router.url}">{{ (offer.TenantName!=null && offer.TenantName!=" ") ? (offer.TenantName) : "-" }}</a></p>
                        </td>
                        <td [hidden]="isBroker">
                          <p>{{ offer.PrimaryContactName }}</p>
                          <!--<p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>-->
                        </td>
                        <td [hidden]="!isBroker">
                          <p class="whitespacenowrap">
                            {{ offer.LeadName }}
                          </p>
                          <p class="whitespacenowrap">
                            {{ offer.LeadEmail }}
                          </p>
                          <p class="whitespacenowrap">
                            {{ offer.LeadPhone | phone }}
                          </p>

                        </td>
                        <td>
                          <p class="whitespacenowrap" *ngIf="offer.Unpriced">Unpriced</p>
                          <p class="whitespacenowrap" *ngIf="!offer.Unpriced">{{(offer.Price!=null&&offer.Price>=0) ? '$ '+ (offer.Price | number:0) : '-'}}</p>
                        </td>
                        <td>
                          <p class="whitespacenowrap">
                            {{(offer.OfferPrice!=null&&offer.OfferPrice>=0) ?'$ '+ (offer.OfferPrice | number:0) : '-'}}
                          </p>
                        </td>
                        <td><p class="whitespacenowrap">{{(offer.EarnestMoneyDeposit) ?'$ '+ (offer.EarnestMoneyDeposit | number:0) : '-'}}</p></td>
                        <td>{{(offer.DueDiligencePeriod) ? (offer.DueDiligencePeriod | number:0) : '-'}}</td>
                        <td>{{(offer.ClosingPeriod) ? (offer.ClosingPeriod | number:0) : '-'}}</td>
                        <td><p class="ellipsis-text commentpara">{{offer.Comments}} <button class="eyeicon" container="body" triggers="focus" popover="{{offer.Comments}}"><i class="fa fa-eye" aria-hidden="true"></i></button></p></td>
                        <td><span class="status-blue">{{offer.StatusName =='Cancelled' ? 'Canceled' :offer.StatusName}}</span><span class="red" *ngIf="offer.IsDraft">(Draft)</span></td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr *ngIf="offers?.length == 0&&!IsLoading ">
                        <td colspan="10" class="odd no-data-available">
                          <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedTab == 2">
    <app-shared-deals-list></app-shared-deals-list>
  </div>
</div>

<ng-template #notestemplate>
  <app-shared-add-notes (close)="closeModal" [modalRef]="modalRef" [notesInputsModel]="NotesInput"></app-shared-add-notes>
</ng-template>

<ng-template #template>
<div class="modal-header">
  <h4 class="modal-title pull-left">Delete Offer Details</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body padding30">

  <div class="form-group">
    <h6 class="displayvalue">Are you sure you want to delete this offer?</h6>
  </div>
  <div class="text-right">
    <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
    <button class="btn btn-lg btn-danger" (click)="deleteOffers();modalRef.hide();">Delete</button>
  </div>
</div>
</ng-template>
<ng-template #BuyerQuestinnaire>
  <app-Buyer-Questionnaire [modalBuyerRef]="modalBuyerRef" [OfferId]="BuyerQuestionsOfferId" [PropertyId]="BuyerQuestionsPropertyId" [source]="'OfferList'"></app-Buyer-Questionnaire>
</ng-template>
